import styled from "styled-components";
import { Layout, Row } from "antd";
const { Header } = Layout;

export const StyledHeader = styled(Header)`
    background: #ffffff;
    position: sticky;
    top: 0;
    z-index: 30;
    width: 100%;
    height: 64px;
    line-height: normal;
    padding: 0 24px;
    border-bottom: 1px solid var(--pl-line, #e2e8f0);
    transition: box-shadow 0.25s ease;

    &.is-scrolled {
        box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);
    }

    @media screen and (max-width: 1125px) {
        /* Mobile View CSS */
        .is-not-mobile {
            display: none !important;
        }
    }

    @media screen and (min-width: 1125.02px) {
        /* Desktop View CSS */
        .is-mobile {
            display: none !important;
        }
    }

    .header-inner {
        max-width: 1200px;
        margin: 0 auto;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
    }

    .logo {
        display: flex;
        align-items: center;
    }

    .logo img {
        height: 26px;
        display: block;
    }

    .header-nav {
        display: flex;
        align-items: center;
        gap: 30px;

        > a {
            color: #1f2937;
            font-weight: 600;
            font-size: 14.5px;
            letter-spacing: 0.01em;
            transition: color 0.2s ease;

            &:hover {
                color: var(--pl-orange, #f26a2e);
            }
        }
    }

    .nav-platform {
        position: relative;
        display: flex;
        align-items: center;
        height: 64px;
    }

    .nav-platform__trigger {
        appearance: none;
        background: none;
        border: none;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-family: inherit;
        color: #1f2937;
        font-weight: 600;
        font-size: 14.5px;
        letter-spacing: 0.01em;
        padding: 0;
        transition: color 0.2s ease;

        &:hover {
            color: var(--pl-orange, #f26a2e);
        }
    }

    .nav-platform__caret {
        display: inline-flex;
        width: 10px;
        transition: transform 0.2s ease;

        svg {
            width: 10px;
            height: 10px;
        }
    }

    .nav-platform.is-open .nav-platform__caret {
        transform: rotate(180deg);
    }

    .nav-platform__panel {
        position: absolute;
        top: calc(100% - 6px);
        left: 50%;
        transform: translate(-50%, 8px);
        width: 640px;
        background: #ffffff;
        border: 1px solid var(--pl-line, #e2e8f0);
        border-radius: 12px;
        box-shadow: 0 30px 70px rgba(15, 23, 42, 0.12);
        padding: 20px;
        display: grid;
        grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
        gap: 20px;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s;
    }

    .nav-platform.is-open .nav-platform__panel {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
        transform: translate(-50%, 0);
    }

    .nav-platform__grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 2px;
    }

    .nav-platform__item {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 9px 10px;
        border-radius: 10px;
        transition: background 0.15s ease;

        &:hover {
            background: var(--pl-tint, #f5f7fb);
            text-decoration: none;

            strong {
                color: var(--pl-orange, #f26a2e);
            }
        }

        strong {
            display: block;
            color: #0f172a;
            font-size: 13.5px;
            font-weight: 600;
            line-height: 1.3;
            transition: color 0.15s ease;
        }

        small {
            display: block;
            color: #64748b;
            font-size: 11.5px;
            line-height: 1.35;
        }
    }

    .nav-platform__icon {
        display: inline-flex;
        color: var(--pl-orange, #f26a2e);
        flex-shrink: 0;
        padding-top: 2px;

        svg {
            width: 16px;
            height: 16px;
        }
    }

    .nav-platform__aside {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .nav-platform__cta {
        background: var(--pl-tint, #f5f7fb);
        border: 1px solid var(--pl-line, #e2e8f0);
        border-radius: 10px;
        padding: 16px;
        flex: 1;

        strong {
            display: block;
            color: #0f172a;
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 6px;
        }

        p {
            color: #64748b;
            font-size: 12.5px;
            line-height: 1.45;
            margin: 0 0 12px;
        }

        a {
            color: var(--pl-orange, #f26a2e);
            font-size: 13px;
            font-weight: 700;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .nav-platform__all {
        color: #0f172a;
        font-size: 13px;
        font-weight: 700;
        padding: 0 4px;

        &:hover {
            color: var(--pl-orange, #f26a2e);
            text-decoration: none;
        }
    }

    .nav-platform__foot {
        grid-column: 1 / -1;
        margin: 0;
        padding: 12px 4px 0;
        border-top: 1px solid var(--pl-line, #e2e8f0);
        font-family: var(--pl-mono, ui-monospace, monospace);
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.16em;
        color: #94a3b8;
    }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 18px;

        .login-link {
            color: #1f2937;
            font-size: 14px;
            font-weight: 600;
            transition: color 0.2s ease;

            &:hover {
                color: var(--pl-orange, #f26a2e);
            }
        }

        .try-btn {
            border-radius: 999px;
            background: linear-gradient(135deg, #f26a2e, #fb923c);
            border: none;
            font-weight: 700;
            font-size: 13.5px;
            height: 38px;
            padding: 0 22px;
            box-shadow: 0 8px 20px rgba(242, 106, 46, 0.25);

            &:hover {
                background: linear-gradient(135deg, #f26a2e, #fb923c);
                opacity: 0.92;
            }
        }
    }
`

export const HeaderRow = styled(Row)`
    max-width: 1400px;
    padding: 0 24px;
`
